<div class="health-indicator">
	<div class="status-text">
		{{healthText}}
		<div class="circle status-blank-bg" [class]="backgroundClass(overallHealth)">
			<i [class]="iconClass"></i>
		</div>
	</div>
	<div *ngIf="!noLink">
		<div class="status-bars">
			<div *ngIf="api.user.hide_rtb !== 1 && !asset.is_fixed" [routerLink]="['asset', asset.asset_id]" class="bar status-blank-bg clickable" [class]="backgroundClass(rtbHealth)"></div>
			<div *ngIf="api.user.hide_fdm !== 1 && !asset.is_fixed" [routerLink]="['asset', asset.asset_id, { view: 'exceed' }]" class="bar status-blank-bg clickable" [class]="backgroundClass(fdmHealth)"></div>
			<div *ngIf="api.user.hide_mech !== 1" [routerLink]="['asset', asset.asset_id, { view: 'mech' }]" class="bar status-blank-bg clickable" [class]="backgroundClass(mdHealth)"></div>
		</div>
		<div class="status-bars">
			<div *ngIf="api.user.hide_rtb !== 1 && !asset.is_fixed" [routerLink]="['asset', asset.asset_id]" class="health-badge clickable">RTB</div>
			<div *ngIf="api.user.hide_fdm !== 1 && !asset.is_fixed" [routerLink]="['asset', asset.asset_id, { view: 'exceed' }]" class="health-badge clickable">FDM</div>
			<div *ngIf="api.user.hide_mech !== 1" [routerLink]="['asset', asset.asset_id, { view: 'mech' }]" class="health-badge clickable">MD</div>
		</div>
	</div>
	<div *ngIf="noLink">
		<div class="status-bars">
			<div *ngIf="api.user.hide_rtb !== 1 && !asset.is_fixed" class="bar status-blank-bg" [class]="backgroundClass(rtbHealth)"></div>
			<div *ngIf="api.user.hide_fdm !== 1 && !asset.is_fixed" class="bar status-blank-bg" [class]="backgroundClass(fdmHealth)"></div>
			<div *ngIf="api.user.hide_mech !== 1" class="bar status-blank-bg" [class]="backgroundClass(mdHealth)"></div>
		</div>
		<div class="status-bars">
			<div *ngIf="api.user.hide_rtb !== 1 && !asset.is_fixed" class="health-badge">RTB</div>
			<div *ngIf="api.user.hide_fdm !== 1 && !asset.is_fixed" class="health-badge">FDM</div>
			<div *ngIf="api.user.hide_mech !== 1" class="health-badge">MD</div>
		</div>
	</div>
</div>